import { useQuery } from '@tanstack/vue-query';
import { ref } from 'vue';
import { mapToDomain, User } from '@infuse/e-connector/user/domain';
import { getUser } from '@infuse/api/e-connector/user';

export const useUser = () => {
  const fetchUserId = ref<string | undefined>(undefined);

  const query = useQuery<User>({
    queryKey: ['users', 'detail', fetchUserId],
    enabled: () => !!fetchUserId.value,
    queryFn: async () => {
      const response = await getUser({ id: fetchUserId.value });
      return mapToDomain(response);
    }
  });

  return {
    ...query,
    fetchUserId,
    user: query.data
  };
};
